import {useEffect, useRef, useState} from 'react'

// Chiều rộng vùng vẽ, như bản mẫu: tối thiểu 340, tối đa 1280
export default () => {
    const ref = useRef(null)
    const [width, setWidth] = useState(0)

    useEffect(() => {
        let timer = null
        const measure = () => ref.current && setWidth(Math.max(340, Math.min(1280, ref.current.clientWidth)))
        const onResize = () => {
            clearTimeout(timer)
            timer = setTimeout(measure, 250)
        }

        measure()
        window.addEventListener('resize', onResize)

        return () => {
            clearTimeout(timer)
            window.removeEventListener('resize', onResize)
        }
    }, [])

    return [ref, width]
}
